export default __webpack_public_path__ + "static/media/New York Rangers.cb1efad6.png";